<template>
  <div id="stock-label" ref="label" class="inventory--part-details--stock-label d-none">
    <dl>
      <dt>Part Number</dt>
      <dd>{{ partDetails.partNumber || '-' }}</dd>

      <dt>Alt Number</dt>
      <dd>{{ partDetails.altNumber || '-' }}</dd>

      <dt>NSN Number</dt>
      <dd>{{ partDetails.nsnNumber || '-' }}</dd>

      <dt>Qty</dt>
      <dd>{{ partDetails.qty || '-' }}</dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as printJS from 'print-js';

export default {
  computed: {
    partId() {
      return this.$route.params.partId;
    },
    ...mapGetters('inventoryDetails', ['partDetailsById']),
    partDetails() {
      return this.partDetailsById(this.partId)
    },
  },
  methods: {
    print() {
      this.$refs.label.classList.remove('d-none');
      printJS({
        printable: 'stock-label',
        type: 'html',
        targetStyles: ['*']
      });
      this.$refs.label.classList.add('d-none');
    }
  }
};
</script>

<style lang="scss">
.inventory--part-details--stock-label {
  border: 2px solid black;
  border-radius: 10px;
  font-size: 24px;
  padding: 1.5em 2em;
  width: 400px;
  * + dt {
    margin-top: 1em;
  }
}
</style>

